module.exports = __webpack_public_path__ + "./fonts/CreteRound-Regular.ttf";